<template>
    <div class="contest responsive-height">
        <v-container class="custom-container px-0">
            <v-row dense>
                <v-col cols="12" class="px-6">
                    <TermsAndConditionTabs />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>

import TermsAndConditionTabs from '@/components/Settings/TermsCondition/TermsAndConditionTabs.vue';
export default {
    components: { TermsAndConditionTabs },
}
</script>
